module.exports = __webpack_public_path__ + "media/images/category/music-696471d0fde467565b68626d8770f856.jpg";